@if (mediaType === snackableVideo) {

<picture [ngClass]="pictureCssClass" [id]="pictureId">
    @for (item of mapObject(editiorialMediaQueries); track item) {
    <source
        [media]="item.value"
        [srcset]="constructSnackableImageUrl(contentsSizes.PUSH_SNACKABLE_VIDEO_STANDARD[item.key], item.key)" />
    } @if (desktopUrl) {
    <img
        [ngClass]="videoName && videoId ? 'lazyload s7poster' : 'lazyload'"
        [id]="videoName && videoId ? 's7poster-desktop-' + videoName + '_' + videoId : ''"
        [alt]="desktopAlt"
        [attr.aria-hidden]="'true'"
        [attr.role]="'presentation'"
        [src]="desktopUrl"
        [attr.fetchpriority]="imageFetchPriority ? 'high' : 'auto'"
        [attr.loading]="imageFetchPriority ? 'eager' : 'lazy'"
        data-cs-override-id />
    } @if (videoName && videoId) {
    <img
        class="lazyload s7poster"
        [id]="'s7poster-mobile-' + videoName + '_' + videoId"
        [alt]="mobileAlt"
        [attr.aria-hidden]="'true'"
        [attr.role]="'presentation'"
        [src]="mobileUrl"
        [attr.fetchpriority]="imageFetchPriority ? 'high' : 'auto'"
        [attr.loading]="imageFetchPriority ? 'eager' : 'lazy'"
        data-cs-override-id />
    }
</picture>

} @else {
<!-- When we're not on SSR mode, we don't display images but we keep the container picture for height and width-->
<picture class="media-wrap-square" hDetectViewport (isInViewport)="handleImageInViewPort($event)">
    @if (!isInServerMode()) {
    <source [attr.media]="'all'" [srcset]="productGridImageUrl" />
    <img
        [alt]="desktopAlt"
        [src]="productGridImageUrl"
        [id]="'img-' + imageId"
        height="400"
        width="400"
        [attr.fetchpriority]="imageFetchPriority ? 'high' : 'auto'"
        [attr.loading]="imageFetchPriority ? 'eager' : 'lazy'"
        data-cs-override-id />
    } @else {
    <noscript>
        <img [alt]="desktopAlt" [src]="degradedImgUrl()" [id]="'img-' + imageId" data-cs-override-id />
    </noscript>
    }
</picture>
}
